import { AdgroupFormData } from '@tt4b/ttam-enums';
import { NetStateEnum, StateEnum, useStore } from '@tt4b/ttam-hooks';
import { computed, onMounted, Ref } from '@vue/composition-api';
import { carriersOptionsType } from './types';
import { useStdLocation } from './../location/hooks/index';

export function useDataSource() {
  const { getStore } = useStore();
  const { data: operatorList, run: loadData } = getStore(NetStateEnum.operatorList);

  onMounted(() => {
    loadData();
  });

  return {
    operatorList,
    loadData,
  };
}

export function useOperatorOptions(options: { adgroupData: Ref<AdgroupFormData> }) {
  const { adgroupData } = options;
  const { state } = useStore();
  const operatorList = computed(() => state[StateEnum.operatorList].data.value);
  const { fullCountryCodes } = useStdLocation({
    adgroupData,
  });
  const operatorsOptions = computed(() => {
    const opts: carriersOptionsType[] = [];
    fullCountryCodes?.value?.some(code => {
      if (operatorList?.value?.[code]) {
        const operatorListFiltered = operatorList.value?.[code]
          .filter(item => item.in_use)
          .map(x => ({
            id: x.id,
            value: x.id,
            label: x.i18n_value,
          }));
        opts.push(...operatorListFiltered);
      }
    });
    return opts;
  });

  return {
    operatorsOptions,
  };
}

export function useOperatorName(options: { adgroupData: Ref<AdgroupFormData> }) {
  const { adgroupData } = options;
  const { operatorsOptions } = useOperatorOptions({
    adgroupData,
  });

  const operatorName = computed(() =>
    operatorsOptions.value.filter(e => adgroupData.value.carriers.find(c => c === e.value)).map(e => e.label)
  );

  return {
    operatorName,
  };
}
